var routerConfig = [
    { path: '/hzero-boot/test1', component: function component() { return import('../pages/test1/Test1Page'); }, authorized: true, title: '区块测试页' }
];
export default routerConfig;
